import { FormWithRedux } from '../../FormWithRedux';

export class OsteoporosisInformationForm extends FormWithRedux {

    constructor() {
        super('PathwayInformationForm');
    }

    shouldDisplayFormDetailForIdentifier(identifier) {
        super.shouldDisplayFormDetailForIdentifier(identifier);

        return true;
    }

    isEnabled(identifier) {
        if (identifier != null) {
            return true;
        }
        return false;
    }

    isMandatory() {
        return false;
    }

    getValueType() {
        return null;
    }

    submissionValidation() {
        return [];
    }

    detailString() {
        return this.detail;
    }
}


// WEBPACK FOOTER //
// ./src/forms/dxaScan01/IntroForm/Osteoporosis-InformationForm.js